// Helpers for redirecting to external paywalls (e.g. Stripe Checkout).
// Stripe Checkout responds with X-Frame-Options: DENY, so when our app is
// embedded in an iframe (preview, partner integrations, …) a same-window
// navigation results in a blank page. We detect that case and open the URL
// in a new tab instead.

import { toast } from "sonner";

export function redirectToCheckout(url, navFallback) {
  if (!url) return;
  if (window.top !== window.self) {
    window.open(url, "_blank", "noopener");
    toast.info("Le paiement Stripe s'ouvre dans un nouvel onglet.");
    if (typeof navFallback === "function") navFallback();
  } else {
    window.location.href = url;
  }
}
